<script setup>
import { computed } from 'vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import MacroPreview from 'dashboard/routes/dashboard/conversation/Macros/MacroPreview.vue';

const props = defineProps({
  macro: {
    type: Object,
    default: null,
  },
  show: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['confirm', 'close', 'update:show']);

const localShow = computed({
  get: () => props.show,
  set: val => emit('update:show', val),
});

const onConfirm = () => {
  emit('confirm');
};

const onClose = () => {
  emit('close');
};

const imageFiles = computed(() => {
  if (!props.macro || !props.macro.files) return [];
  return props.macro.files.filter(
    file => file.file_type && file.file_type.includes('image')
  );
});
</script>

<template>
  <div class="column">
    <woot-modal v-model:show="localShow" :on-close="onClose">
      <div class="column content-box">
        <woot-modal-header
          :header-title="
            $t('MACROS.EXECUTE.CONFIRM_TITLE', { name: macro?.name })
          "
          :header-content="$t('MACROS.EXECUTE.CONFIRM_MESSAGE')"
        />
        <div class="p-6 relative">
          <MacroPreview
            v-if="macro"
            :macro="macro"
            class="!relative !inset-0 !bottom-0 !right-0 !w-full !max-h-[15rem] !mb-4 border-none shadow-none bg-n-alpha-1"
          />
          <div v-if="imageFiles.length" class="mt-4 flex flex-wrap gap-2">
            <div
              v-for="file in imageFiles"
              :key="file.id || file.file_url"
              class="relative rounded-lg overflow-hidden border border-n-weak"
            >
              <img
                :src="file.file_url"
                :alt="file.filename"
                class="w-full h-auto max-h-32 object-contain"
              />
            </div>
          </div>
        </div>
        <div
          class="modal-footer flex items-center justify-end gap-2 px-6 pb-6 cursor-pointer"
        >
          <NextButton
            faded
            slate
            :label="$t('MACROS.EXECUTE.CANCEL')"
            @click.prevent="onClose"
          />
          <NextButton
            :label="$t('MACROS.EXECUTE.CONFIRM')"
            @click.prevent="onConfirm"
          />
        </div>
      </div>
    </woot-modal>
  </div>
</template>
